module.exports = __webpack_public_path__ + "static/media/IGS-teal-faces.24f6596e.png";